import { useGetApiV1ThreeLetterCodeClientAdminsClientPortalItems } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetPortalItems = useGetApiV1ThreeLetterCodeClientAdminsClientPortalItems;
